<template>

  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="dialog = false" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>

      <v-container>
        <h3 class="primary--text text-center font-weight-bold pt-3">
          {{ $t('legal:conditions.title') }}
        </h3>
        <v-card
          elevation="0"
          flat
          tile
        >
          <v-card-text class="px-8 py-5">
            <!-- General terms and conditions -->
            <p class="text-h6 font-weight-bold">{{ $t('legal:conditions.1') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.1-1') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.1-2') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.1-3') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.1-4') }}</p>

            <!-- Scope -->
            <p class="text-body-1"><span class="text-h6 font-weight-bold">{{ $t('legal:conditions.2') }}</span><br>{{ $t('legal:conditions.2-sub') }}</p>

            <!-- Offer and scope of delivery -->
            <p class="text-h6 font-weight-bold">{{ $t('legal:conditions.3') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.3-1') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.3-2') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.3-3') }}</p>

            <!-- Price and payment -->
            <p class="text-h6 font-weight-bold">{{ $t('legal:conditions.4') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.4-1') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.4-2') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.4-3') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.4-4') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.4-5') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.4-6') }}</p>

            <!-- Property rights -->
            <p class="text-h6 font-weight-bold">{{ $t('legal:conditions.5') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.5-1') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.5-2') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.5-3') }}</p>

            <!-- Warranty and liability -->
            <p class="text-h6 font-weight-bold">{{ $t('legal:conditions.6') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.6-1') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.6-2') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.6-3') }}</p>

            <!-- Right of use -->
            <p class="text-h6 font-weight-bold">{{ $t('legal:conditions.7') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.7-1') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.7-2') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.7-3') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.7-4') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.7-5') }}</p>

            <!-- Contents -->
            <p class="text-h6 font-weight-bold">{{ $t('legal:conditions.8') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.8-1') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.8-2') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.8-3') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.8-4') }}</p>

            <!-- Service fees and maintenance contracts -->
            <p class="text-h6 font-weight-bold">{{ $t('legal:conditions.9') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.9-sub') }}</p>

            <!-- Customer data and data protection -->
            <p class="text-h6 font-weight-bold">{{ $t('legal:conditions.10') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.10-sub-1') }}</p>
            <p class="text-body-1">{{ $t('legal:conditions.10-sub-2') }}<br>
              {{ $t('legal:conditions.10-sub-3') }}<br>
              {{ $t('legal:conditions.10-sub-4') }}<br>
              {{ $t('legal:conditions.10-sub-5') }}<br>
              {{ $t('legal:conditions.10-sub-6') }}</p>

            <!-- status of terms -->
            <p class="text-body-1 pt-5">{{ $t('legal:conditions.date') }}</p>
          </v-card-text>
        </v-card>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "ConditionsComponent",
  data() {
    return {
      dialog: false
    }
  }
}
</script>